var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("Activate", {
    attrs: {
      submit: _vm.submit,
      "validate-token": _vm.validatePerishableToken,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }